import yarnIcons from './assets/images/menuItems/icon-01-01.png';
import fabricIcons from './assets/images/menuItems/icon-01-04.png';
import knittingIcons from './assets/images/menuItems/icon-01-02.png';
import dyeingIcons from './assets/images/menuItems/icon-01-05.png';
import compactingIcons from './assets/images/menuItems/icon-01-06.png';
import printingIcons from './assets/images/menuItems/icon-01-08.png';
import stitchingIcons from './assets/images/menuItems/stitch.png';
import cuttingIcons from './assets/images/menuItems/cutting.png';
import ironingPackingIcons from './assets/images/menuItems/icon-01-10.png';
import despatchIcons from './assets/images/menuItems/icon-01-11.png';
import dashboardIcon from './assets/images/menuItems/dashboard.png';
import propertyMasterIcon from './assets/images/menuItems/propertyMaster.png';
import stateMasterIcon from './assets/images/menuItems/stateMaster.png';
import areaMasterIcon from './assets/images/menuItems/areaMaster.png';
import companyMasterIcon from './assets/images/menuItems/companyMaster.png';
import unitMasterIcon from './assets/images/menuItems/unitMaster.png';
import sectionIcon from './assets/images/menuItems/section.png';
import partyMasterDetailsIcon from './assets/images/menuItems/partyMaster&Details.png';
import yearMasterIcon from './assets/images/menuItems/yearMaster.png';
import seasonMasterIcon from './assets/images/menuItems/seasonMaster.png';
import brandMasterIcon from './assets/images/menuItems/brandMaster.png';
import colorMasterIcon from './assets/images/menuItems/colorMaster.png';
import sizeInfoIcon from './assets/images/menuItems/sizeInfo.png';
import hsnMasterIcon from './assets/images/menuItems/hsnMaster.png';
import yarnMasterIcon from './assets/images/menuItems/yarnMaster.png';
import fabricMasterIcon from './assets/images/menuItems/fabricMaster.png';
import accessoriesMasterUsageIcon from './assets/images/menuItems/accessoriesMaster&Usage.png';
import productIcon from './assets/images/menuItems/product.png';
import bankMasterIcon from './assets/images/menuItems/bankMaster.png';
import menuMasterIcon from './assets/images/menuItems/menuMaster.png';
import employeeMasterIcon from './assets/images/menuItems/employeeMaster.png';
import teamMasterIcon from './assets/images/menuItems/teamMaster.png';
import stockIcon from './assets/images/menuItems/stock.png';
import styleCreationIcon from './assets/images/menuItems/styleCreation.png';
import generalAccesoriesDCIcon from './assets/images/menuItems/general&accesoriesDC.png';
import generalAccessoriesPOIcon from './assets/images/menuItems/general&accessoriesPO.png';
import PIMIcon from './assets/images/menuItems/PIM.png';
import billEntriesIcon from './assets/images/menuItems/billEntries.jpg';
import verifiedBillsIcon from './assets/images/menuItems/VerifiedBills.png';
import billPaymentsIcon from './assets/images/menuItems/billPayments.png';
import programWiseReportIcon from './assets/images/menuItems/programWiseReport.png';
import salesOrderIcon from './assets/images/menuItems/salesOrder.png';
import programMappingIcon from './assets/images/menuItems/programMapping.png';
import programConstraintIcon from './assets/images/menuItems/programConstraint.png';
import programAssignStyleMasterIcon from './assets/images/menuItems/programAssignStyleMaster.png';
import rolesIcon from './assets/images/menuItems/roles.png';
import uesrHeaderIcon from './assets/images/menuItems/uesrHeader.png';
import userAccInfoIcon from './assets/images/menuItems/userAccInfo.png';
import yarnProjectionIcon from './assets/images/menuItems/yarnimages.jpg';
import settingsIcon from './assets/images/menuItems/settings.png';
import auditIcon from './assets/images/menuItems/audit.png';

// eslint-disable-next-line import/no-anonymous-default-export
export default [
    {
        id: 'navigation',
        title: 'DASHBOARD',
        type: 'group',
        icon: 'icon-navigation',
        img: dashboardIcon,
        children: [
            //   {
            //       id: 'Dashboard',
            //       title: 'Dashboard',
            //       type: 'item',
            //       url: '/dashboard',
            //       classes: 'nav-item',
            //       icon: 'feather icon-home'
            //   },
            {
                id: 'DashboardBulk',
                title: 'Dashboard Bulk',
                type: 'item',
                url: '/bulk/dashboard',
                classes: 'nav-item',
                icon: 'feather icon-home',
                img: dashboardIcon
            }
        ]
    },
    {
        id: 'Masters',
        title: 'MASTERS',
        type: 'group',
        icon: 'icon-support',
        children: [
            {
                id: 'PropertyMaster',
                title: 'Property Master',
                type: 'collapse',
                url: '/property-master',
                icon: 'feather icon-menu',
                img: propertyMasterIcon,
                children: [
                    {
                        id: 'Property',
                        title: 'Property',
                        type: 'item',
                        url: '/properties',
                        classes: 'nav-item',
                        icon: 'feather icon-sidebar',
                        img: propertyMasterIcon
                    },
                    {
                        id: 'Property2',
                        title: 'Property2',
                        type: 'item2',
                        url: '/properties',
                        classes: 'nav-item',
                        icon: 'feather icon-sidebar'
                    }
                ]
            },
            {
                id: 'Settings',
                title: 'Settings',
                type: 'item',
                url: '/settings',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: settingsIcon
            },
            {
                id: 'Audit Log',
                title: 'Audit Log',
                type: 'item',
                url: '/audit-log',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: auditIcon
            },
            {
                id: 'StateMaster',
                title: 'State Master',
                type: 'item',
                url: '/state-master',
                classes: 'nav-item',
                icon: 'feather icon-layers',
                img: stateMasterIcon
            },
            {
                id: 'AreaMaster',
                title: 'Area Master',
                type: 'item',
                url: '/area-master',
                classes: 'nav-item',
                icon: 'feather icon-map',
                img: areaMasterIcon
            },
            {
                id: 'CompanyMaster',
                title: 'Company Master',
                type: 'item',
                url: '/company-master',
                classes: 'nav-item',
                icon: 'feather icon-menu',
                img: companyMasterIcon
            },
            {
                id: 'UnitMaster',
                title: 'Unit Master',
                type: 'item',
                url: '/unit-master',
                classes: 'nav-item',
                icon: 'feather icon-sidebar',
                img: unitMasterIcon
            },
            {
                id: 'ArticleMaster',
                title: 'Article Master',
                type: 'item',
                url: '/article-master',
                classes: 'nav-item',
                icon: 'feather icon-sidebar',
                img: unitMasterIcon
            },




            {
                id: 'section',
                title: 'Section',
                type: 'item',
                url: '/section',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: sectionIcon
            },
            {
                id: 'PartyMaster',
                title: 'Party Master',
                type: 'item',
                url: '/party-master',
                classes: 'nav-item',
                icon: 'feather icon-sidebar',
                img: partyMasterDetailsIcon
            },
            {
                id: 'PartyDetails',
                title: 'Party Details',
                type: 'item',
                url: '/party-details',
                classes: 'nav-item',
                icon: 'feather icon-sidebar',
                img: partyMasterDetailsIcon
            },
            {
                id: 'VendorCreation',
                title: 'Vendor Creation',
                type: 'item',
                url: '/vendor-creation',
                classes: 'nav-item',
                icon: 'feather icon-sidebar',
                img: partyMasterDetailsIcon
            },
            {
                id: 'RegisteredVendor',
                title: 'Registered Vendor',
                type: 'item',
                url: '/registered-vendor',
                classes: 'nav-item',
                icon: 'feather icon-sidebar',
                img: partyMasterDetailsIcon
            },
            {
                id: 'PendingVendor',
                title: 'Pending Vendor',
                type: 'item',
                url: '/pending-vendor',
                classes: 'nav-item',
                icon: 'feather icon-sidebar',
            },
            {
                id: 'YearMaster',
                title: 'Year Master',
                type: 'item',
                url: '/year-master',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: yearMasterIcon
            },
            {
                id: 'SeasonMaster',
                title: 'Season Master',
                type: 'item',
                url: '/season-master',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: seasonMasterIcon
            },
            {
                id: 'brandMaster',
                title: 'Brand Master',
                type: 'item',
                url: '/brand-master',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: brandMasterIcon
            },
            {
                id: 'ColourMaster',
                title: 'Colour Master',
                type: 'item',
                url: '/colour-master',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: colorMasterIcon
            },
            {
                id: 'Size Info',
                title: 'Size Info',
                type: 'item',
                url: '/size-info',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: sizeInfoIcon
            },
            //   {
            //       id: 'SizwMeasurementMaster',
            //       title: 'Size Measurement Master',
            //       type: 'item',
            //       url: '/size-measurement-master',
            //       classes: 'nav-item',
            //       icon: 'feather icon-box',
            //       img: sizeInfoIcon
            //   },
            {
                id: 'HSNMaster',
                title: 'HSN Master',
                type: 'item',
                url: '/hsn-master',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: hsnMasterIcon
            },
            {
                id: 'yarnMaster',
                title: 'Yarn Master',
                type: 'item',
                url: '/yarn-master',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: yarnMasterIcon
            },
            {
                id: 'fabricMaster',
                title: 'Fabric Master',
                type: 'item',
                url: '/fabric-master',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: fabricMasterIcon
            },
            {
                id: 'AccessoriesMaster',
                title: 'Accessories Master',
                type: 'item',
                url: '/accessories-master',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: accessoriesMasterUsageIcon
            },
            {
                id: 'ColorwiseCost',
                title: 'Colorwise Cost',
                type: 'item',
                url: '/color-wise-cost',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: accessoriesMasterUsageIcon
            },
            {
                id: 'AccessoriesUsage',
                title: 'Accessories Usage',
                type: 'item',
                url: '/accessories-usage',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: accessoriesMasterUsageIcon
            },

            {
                id: 'PriceMapping',
                title: 'Price Mapping',
                type: 'item',
                url: '/price-mapping',
                classes: 'nav-item',
                icon: 'feather icon-box'
            },
            {
                id: 'Product',
                title: 'Product',
                type: 'item',
                url: '/product',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: productIcon
            },
            {
                id: 'BankMaster',
                title: 'Bank Master',
                type: 'item',
                url: '/bank-master',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: bankMasterIcon
            },
            // {
            //     id: 'AccountMaster',
            //     title: 'Account Master',
            //     type: 'item',
            //     url: '/account-master',
            //     classes: 'nav-item',
            //     icon: 'feather icon-box',
            //     img: bankMasterIcon
            // },
            // {
            //     id: 'AccountTransaction',
            //     title: 'Account Transaction',
            //     type: 'item',
            //     url: '/account-transaction',
            //     classes: 'nav-item',
            //     icon: 'feather icon-box',
            //     img: bankMasterIcon
            // },
            {
                id: 'MenuMaster',
                title: 'Menu Master',
                type: 'item',
                url: '/menu-master',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: menuMasterIcon
            },
            {
                id: 'Employee',
                title: 'Employee',
                type: 'item',
                url: '/employee',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: employeeMasterIcon
            },
            {
                id: 'TeamMaster',
                title: 'Team Master',
                type: 'item',
                url: '/team-master',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: teamMasterIcon
            },
            {
                id: 'filter',
                title: 'Filter',
                type: 'item',
                url: '/filter',
                classes: 'nav-item',
                icon: 'feather icon-box'
            },
            {
                id: 'Barcode',
                title: 'Barcode',
                type: 'item',
                url: '/barcode',
                classes: 'nav-item',
                icon: 'feather icon-box'
            },
            {
                id: 'Stock',
                title: 'Stock',
                type: 'item',
                url: '/stock',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: stockIcon
            },
            {
                id: 'Price List',
                title: 'Price List',
                type: 'item',
                url: '/price-list',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: billEntriesIcon
            },




            //   {
            //       id: 'SKUMasterBulk',
            //       title: 'SKU Master Bulk',
            //       type: 'item',
            //       url: '/bulk/SKU-master',
            //       classes: 'nav-item',
            //       icon: 'feather icon-box'
            //   }
        ]
    },

    {
        id: 'Style',
        title: 'STYLE',
        type: 'group',
        icon: 'icon-support',
        children: [
            {
                id: 'styleCreation',
                title: 'Style Creation',
                type: 'item',
                url: '/style-creation',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: styleCreationIcon
            },
            {
                id: 'styleUpCharge',
                title: 'Style Upcharge',
                type: 'item',
                url: '/style-upCharge',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: styleCreationIcon
            },
            {
                id: 'defaultStyleMaster',
                title: 'Default Style Detail',
                type: 'item',
                url: '/default-style-detail',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: styleCreationIcon
            },
            {
                id: 'fabricCreation',
                title: 'Style Verification - Fabric',
                type: 'item',
                url: '/style-verification-fabric',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: styleCreationIcon
            },
            {
                id: 'merchCreation',
                title: 'Style Verification - Merch',
                type: 'item',
                url: '/style-verification-merch',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: styleCreationIcon
            },

            {
                id: 'fabricRoughCosting',
                title: 'Fabric Rough Costing',
                type: 'item',
                url: '/fabric-rough-costing',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: styleCreationIcon
            },

            // {
            //     id: 'stylePreparation',
            //     title: 'Style Preparations',
            //     type: 'item',
            //     url: '/style-preparation',
            //     classes: 'nav-item',
            //     icon: 'feather icon-anchor'
            // }
        ]
    },
    {
        id: 'Program',
        title: 'PROGRAM',
        type: 'group',
        icon: 'icon-support',
        children: [
            {
                id: 'yarnPo',
                title: 'Yarn PO',
                type: 'item',
                url: '/yarn-po',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: yarnIcons,
                // visibleTo: ['admin']
            },


            //   {
            //       id: 'yarnPoBulk',
            //       title: 'Yarn PO Bulk',
            //       type: 'item',
            //       url: '/bulk/yarn-po',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: yarnIcons
            //   },
            {
                id: 'yarnInward',
                title: 'Yarn Inward',
                type: 'item',
                url: '/yarn-inward',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: yarnIcons
            },
            {
                id: 'yarnProjection',
                title: 'Yarn Projection',
                type: 'item',
                url: '/yarn-projection',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: yarnProjectionIcon
            },
            //   {
            //       id: 'yarnInwardBulk',
            //       title: 'Yarn Inward Bulk',
            //       type: 'item',
            //       url: '/bulk/yarn-inward',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: yarnIcons
            //   },
            {
                id: 'fabricPo',
                title: 'Fabric PO',
                type: 'item',
                url: '/fabric-po',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: fabricIcons
            },
            //   {
            //       id: 'fabricPoBulk',
            //       title: 'Fabric PO Bulk',
            //       type: 'item',
            //       url: '/bulk/fabric-po',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: fabricIcons
            //   },
            {
                id: 'fabricInward',
                title: 'Fabric Inward',
                type: 'item',
                url: '/fabric-inward',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: fabricIcons
            },
            {
                id: 'fabricProjection',
                title: 'Fabric Projection',
                type: 'item',
                url: '/fabric-projection',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: fabricIcons
            },
            //   {
            //       id: 'fabricInwardBulk',
            //       title: 'Fabric Inward Bulk',
            //       type: 'item',
            //       url: '/bulk/fabric-inward',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: fabricIcons
            //   },
            //   {
            //       id: 'fabricDc',
            //       title: 'Fabric DC',
            //       type: 'item',
            //       url: '/fabric-dc',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: fabricIcons
            //   },
            {
                id: 'knittingDC',
                title: 'Knitting DC',
                type: 'item',
                url: '/knitting-dc',
                classes: 'nav-item',
                icon: 'feather icon-hash',
                img: knittingIcons
            },
            //   {
            //       id: 'knittingDCBulk',
            //       title: 'Knitting DC Bulk',
            //       type: 'item',
            //       url: '/bulk/knitting-dc',
            //       classes: 'nav-item',
            //       icon: 'feather icon-hash',
            //       img: knittingIcons
            //   },
            {
                id: 'knittingInward',
                title: 'Knitting Inward',
                type: 'item',
                url: '/knitting-inward',
                classes: 'nav-item',
                icon: 'feather icon-hash',
                img: knittingIcons
            },
            //   {
            //       id: 'knittingInwardBulk',
            //       title: 'Knitting Inward Bulk',
            //       type: 'item',
            //       url: '/bulk/knitting-inward',
            //       classes: 'nav-item',
            //       icon: 'feather icon-hash',
            //       img: knittingIcons
            //   },
            {
                id: 'dyeingDC',
                title: 'Dyeing DC',
                type: 'item',
                url: '/dyeing-dc',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: dyeingIcons
            },
            //   {
            //       id: 'dyeingDCBulk',
            //       title: 'Dyeing/Washing DC Bulk',
            //       type: 'item',
            //       url: '/bulk/dyeing-dc',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: dyeingIcons
            //   },
            {
                id: 'dyeingInward',
                title: 'Dyeing Inward',
                type: 'item',
                url: '/dyeing-inward',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: dyeingIcons
            },
            //   {
            //       id: 'dyeingInwardBulk',
            //       title: 'Dyeing/Washing Inward Bulk',
            //       type: 'item',
            //       url: '/bulk/dyeing-inward',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: dyeingIcons
            //   },
            {
                id: 'compactingDC',
                title: 'Compacting DC',
                type: 'item',
                url: '/compacting-dc',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: compactingIcons
            },
            {
                id: 'processDC',
                title: 'Process DC',
                type: 'item',
                url: '/process-dc',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: compactingIcons

            },
            //   {
            //       id: 'compactingDCBulk',
            //       title: 'Compacting DC Bulk',
            //       type: 'item',
            //       url: '/bulk/compacting-dc',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: compactingIcons
            //   },
            {
                id: 'compactingInward',
                title: 'Compacting Inward',
                type: 'item',
                url: '/compacting-inward',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: compactingIcons
            },

            {
                id: 'ProcessInward',
                title: 'Process Inward',
                type: 'item',
                url: '/process-inward',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: compactingIcons
            },
            //   {
            //       id: 'compactingInwardBulk',
            //       title: 'Compacting Inward Bulk',
            //       type: 'item',
            //       url: '/bulk/compacting-dc-inward',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: compactingIcons
            //   },
            {
                id: 'allOverPrintingDc',
                title: 'All Over Printing DC',
                type: 'item',
                url: '/all-over-printing-dc',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: printingIcons
            },
            {
                id: 'allOverPrintingDcInward',
                title: 'All Over Printing Inward',
                type: 'item',
                url: '/all-over-printing-inward',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: printingIcons


            },
            {
                id: 'printingDc',
                title: 'Printing DC',
                type: 'item',
                url: '/printing-dc',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: printingIcons
            },

            {
                id: 'programDc',
                title: 'Program DC',
                type: 'item',
                url: '/program-dc',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: printingIcons
            },


            {
                id: 'Program DC Inward',
                title: 'Program DC Inward',
                type: 'item',
                url: '/program-inward',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: compactingIcons
            },


            //   {
            //       id: 'allOverPrintingDcBulk',
            //       title: 'All Over Printing DC',
            //       type: 'item',
            //       url: '/bulk/all-over-printing-dc',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: printingIcons
            //   },
            {
                id: 'allOverPrintingInward',
                title: 'Printing Inward',
                type: 'item',
                url: '/printing-inward',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: printingIcons
            },
            //   {
            //       id: 'printingInwardBulk',
            //       title: 'All Over Printing Inward',
            //       type: 'item',
            //       url: '/bulk/all-over-printing-dc-inward',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: printingIcons
            //   },
            // {
            //     id: 'washingDCBulk',
            //     title: 'Washing DC Bulk',
            //     type: 'item',
            //     url: '/bulk/washing-dc',
            //     classes: 'nav-item',
            //     icon: 'feather icon-anchor'
            // },
            // {
            //     id: 'washingInwardBulk',
            //     title: 'Washing Inward Bulk',
            //     type: 'item',
            //     url: '/bulk/washing-dc-inward',
            //     classes: 'nav-item',
            //     icon: 'feather icon-anchor'
            // },
            {
                id: 'cuttingDc',
                title: 'Cutting DC',
                type: 'item',
                url: '/cutting-dc',
                classes: 'nav-item',
                icon: 'cutting.png',
                img: cuttingIcons
            },

            {
                id: 'GarmentsPo',
                title: 'Garments PO',
                type: 'item',
                url: '/garments-po',
                classes: 'nav-item',
                icon: 'cutting.png',
                img: cuttingIcons
            },
            //   {
            //       id: 'cuttingDcBulk',
            //       title: 'Cutting DC Bulk',
            //       type: 'item',
            //       url: '/bulk/cutting-dc',
            //       classes: 'nav-item',
            //       icon: 'feather icon-scissors',
            //       img: cuttingIcons
            //   },
            {
                id: 'GarmentsInward',
                title: 'Garments Inward',
                type: 'item',
                url: '/garments-inward',
                classes: 'nav-item',
                icon: 'feather icon-scissors',
                img: cuttingIcons
            },

            {
                id: 'customerPo',
                title: 'Customer PO',
                type: 'item',
                url: '/customer-po',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: yarnIcons,
            },

            {
                id: 'cuttingInward',
                title: 'Cutting Inward',
                type: 'item',
                url: '/cutting-inward',
                classes: 'nav-item',
                icon: 'feather icon-scissors',
                img: cuttingIcons
            },

            {
                id: 'cuttingProgram',
                title: 'Cutting Program',
                type: 'item',
                url: '/cutting-program',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: salesOrderIcon
            },

            {
                id: 'Dyeing Details',
                title: 'Dyeing Details',
                type: 'item',
                url: '/dyeing-details',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: billEntriesIcon
            },

            {
                id: 'ProgramCatalogues',
                title: 'Program Catalogues',
                type: 'item',
                url: '/program-catalogues',
                classes: 'nav-item',
                icon: 'feather icon-sidebar',
                img: unitMasterIcon
            },

            {
                id: 'RequestForm',
                title: 'Request Form',
                type: 'item',
                url: '/request-form',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: salesOrderIcon
            },




            // {
            //     id: 'cuttingReportsView',
            //     title: 'Cutting Reports View',
            //     type: 'item',
            //     url: '/cutting-reports-view',
            //     classes: 'nav-item',
            //     icon: 'feather icon-box',
            //     img: salesOrderIcon
            // },


            {
                id: 'stylesInProgress',
                title: 'Styles In Progress',
                type: 'item',
                url: '/styles-progress',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: salesOrderIcon
            },


            {
                id: 'gateEntry',
                title: 'Gate Entry',
                type: 'item',
                url: '/gate-entry-scan',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: salesOrderIcon
            },
            {
    id: 'gatePass',
    title: 'Gate Pass',
    type: 'item',
    url: '/gate-pass',
    classes: 'nav-item',
    icon: 'feather icon-box',
    img: despatchIcons
},

            {
                id: 'SampleDCApproval',
                title: 'Sample Approval',
                type: 'item',
                url: '/sample-approval',
                classes: 'nav-item',
                icon: 'feather icon-sidebar',
                img: generalAccessoriesPOIcon
            },

            //   {
            //       id: 'cuttingInwardBulk',
            //       title: 'Cutting Inward Bulk',
            //       type: 'item',
            //       url: '/bulk/cutting-dc-inward',
            //       classes: 'nav-item',
            //       icon: 'feather icon-scissors',
            //       img: cuttingIcons
            //   },
            //   {
            //       id: 'printingDcBulk',
            //       title: 'Printing DC Bulk',
            //       type: 'item',
            //       url: '/bulk/printing-dc',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: printingIcons
            //   },
            //   {
            //       id: 'printingDcInwardBulk',
            //       title: 'Printing Inward Bulk',
            //       type: 'item',
            //       url: '/bulk/printing-inward',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: printingIcons
            //   },
            {
                id: 'stitchingDc',
                title: 'Stitching DC',
                type: 'item',
                url: '/stitching-dc',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: stitchingIcons
            },
            //   {
            //       id: 'stitchingDcBulk',
            //       title: 'Stitching DC Bulk',
            //       type: 'item',
            //       url: '/bulk/stitching-dc',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: stitchingIcons
            //   },
            {
                id: 'stitchingInward',
                title: 'Stitching Inward',
                type: 'item',
                url: '/stitching-inward',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: stitchingIcons
            },


            //   {
            //       id: 'stitchingInwardBulk',
            //       title: 'Stitching Inward Bulk',
            //       type: 'item',
            //       url: '/bulk/stitching-inward',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: stitchingIcons
            //   },
            // {
            //     id: 'checkingDc',
            //     title: 'Checking DC',
            //     type: 'item',
            //     url: '/checking-dc',
            //     classes: 'nav-item',
            //     icon: 'feather icon-check-circle'
            // },
            // {
            //     id: 'checkingDcInward',
            //     title: 'Checking DC Inward',
            //     type: 'item',
            //     url: '/checking-dc-inward',
            //     classes: 'nav-item',
            //     icon: 'feather icon-check-circle'
            // },
            {
                id: 'ironing/packingDc',
                title: 'Ironing/Packing DC',
                type: 'item',
                url: '/ironing-and-packing-dc',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: ironingPackingIcons
            },
            //   {
            //       id: 'ironing/packingDcBulk',
            //       title: 'Ironing/Packing DC Bulk',
            //       type: 'item',
            //       url: '/bulk/ironing-packing-dc',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: ironingPackingIcons
            //   },
            {
                id: 'ironing/packingDcInward',
                title: 'Ironing/Packing DC Inward',
                type: 'item',
                url: '/ironingAndPacking-inward',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: ironingPackingIcons
            },
            //   {
            //       id: 'ironing/packingDcInwardBulk',
            //       title: 'Ironing/Packing DC Inward Bulk',
            //       type: 'item',
            //       url: '/bulk/ironing/packing-dc-inward',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: ironingPackingIcons
            //   },
            {
                id: 'despatchDC',
                title: 'Despatch DC',
                type: 'item',
                url: '/despatch-dc',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: despatchIcons
            },

            {
                id: 'pickupProgram',
                title: 'Pickup Entry',
                type: 'item',
                url: '/pickup-entry',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: despatchIcons
            },
            {
                id: 'pickupInfo',
                title: 'Pickup Info',
                type: 'item',
                url: '/pickup-info',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: despatchIcons
            },

            //   {
            //       id: 'despatchDc',
            //       title: 'Despatch DC',
            //       type: 'item',
            //       url: '/despatchs-dc',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: despatchIcons
            //   },
            {
                id: 'generalPo',
                title: 'General PO',
                type: 'item',
                url: '/general-po',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: generalAccessoriesPOIcon
            },

            {
                id: 'SamplePo',
                title: 'Sample PO',
                type: 'item',
                url: '/sample-po',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: generalAccessoriesPOIcon
            },

            //   {
            //       id: 'generalPoBulk',
            //       title: 'General PO Bulk',
            //       type: 'item',
            //       url: '/bulk/general-po',
            //       classes: 'nav-item',
            //       icon: 'feather icon-briefcase',
            //       img: generalAccessoriesPOIcon
            //   },
            {
                id: 'generalPoInward',
                title: 'General PO Inward',
                type: 'item',
                url: '/general-po-inward',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: generalAccessoriesPOIcon
            },

            {
                id: 'samplePoInward',
                title: 'Sample PO Inward',
                type: 'item',
                url: '/sample-po-inward',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: generalAccessoriesPOIcon
            },


            {
                id: 'MiscellaneousDC',
                title: 'Miscellaneous DC',
                type: 'item',
                url: '/miscellaneous-dc',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: generalAccesoriesDCIcon
            },

            {
                id: 'SampleDC',
                title: 'Sample DC',
                type: 'item',
                url: '/sample-dc',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: generalAccesoriesDCIcon
            },

            {
                id: 'sampleDCInward',
                title: 'Sample DC Inward',
                type: 'item',
                url: '/sample-dc-inward',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: generalAccesoriesDCIcon
            },

            //   {
            //       id: 'generalPoInwardBulk',
            //       title: 'General PO Inward Bulk',
            //       type: 'item',
            //       url: '/bulk/general-inward',
            //       classes: 'nav-item',
            //       icon: 'feather icon-briefcase',
            //       img: generalAccessoriesPOIcon
            //   },
            {
                id: 'generalDc',
                title: 'General DC',
                type: 'item',
                url: '/general-dc',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: generalAccesoriesDCIcon
            },
            {
                id: 'adminDC',
                title: 'Admin DC/PO',
                type: 'item',
                url: '/admin-dc',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: generalAccesoriesDCIcon
            },
            //   {
            //       id: 'generalDcBulk',
            //       title: 'General DC Bulk',
            //       type: 'item',
            //       url: '/bulk/general-dc',
            //       classes: 'nav-item',
            //       icon: 'feather icon-briefcase',
            //       img: generalAccesoriesDCIcon
            //   },
            {
                id: 'generalDcInward',
                title: 'General DC Inward',
                type: 'item',
                url: '/general-dc-inward',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: generalAccesoriesDCIcon
            },
            {
                id: 'adminInward',
                title: 'Admin Inward',
                type: 'item',
                url: '/admin-inward',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: generalAccesoriesDCIcon
            },
            //   {
            //       id: 'generalDcInwardBulk',
            //       title: 'General DC Inward Bulk',
            //       type: 'item',
            //       url: '/bulk/general-dc-inward',
            //       classes: 'nav-item',
            //       icon: 'feather icon-briefcase',
            //       img: generalAccesoriesDCIcon
            //   },

            {
                id: 'moveToCutting',
                title: 'Move To Cutting',
                type: 'item',
                url: '/move-to-cutting',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: billEntriesIcon
            },

            {
                id: 'accessoriesPo',
                title: 'Accessories PO',
                type: 'item',
                url: '/accessories-po',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: generalAccessoriesPOIcon
            },
            // {
            //     id: 'accessoriesPoBulk',
            //     title: 'Accessories PO Bulk',
            //     type: 'item',
            //     url: '/bulk/accessories-po',
            //     classes: 'nav-item',
            //     icon: 'feather icon-anchor',
            //     img: generalAccessoriesPOIcon
            // },
            {
                id: 'accessoriesPoInward',
                title: 'Accessories PO Inward',
                type: 'item',
                url: '/accessories-po-inward',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: generalAccessoriesPOIcon
            },
            //   {
            //       id: 'accessoriesPoInwardBulk',
            //       title: 'Accessories PO Inward Bulk',
            //       type: 'item',
            //       url: '/bulk/accessories-po-inward',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: generalAccessoriesPOIcon
            //   },
            {
                id: 'accessoriesDc',
                title: 'Accessories DC',
                type: 'item',
                url: '/accessories-dc',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: generalAccesoriesDCIcon
            },
             {
                id: 'accessoriesDesp',
                title: 'Accessories Despatch',
                type: 'item',
                url: '/accessories-despatch',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: generalAccesoriesDCIcon
            },
            {
                id: 'accessoriesProcessDc',
                title: 'Accessories General/Process DC',
                type: 'item',
                url: '/accessories-process-dc',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: generalAccesoriesDCIcon
            },
            {
                id: 'accessoriesProcessDcInward',
                title: 'Accessories General/Process DC Inward',
                type: 'item',
                url: '/accessories-process-dc-inward',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: generalAccesoriesDCIcon
            },


            // {
            //     id: 'AccountProperty',
            //     title: 'Account Property',
            //     type: 'item',
            //     url: '/account-property',
            //     classes: 'nav-item',
            //     icon: 'feather icon-box',
            //     img: bankMasterIcon
            // },

            //   {
            //       id: 'accessoriesDcBulk',
            //       title: 'Accessories DC Bulk',
            //       type: 'item',
            //       url: '/bulk/accessories-dc',
            //       classes: 'nav-item',
            //       icon: 'feather icon-anchor',
            //       img: generalAccesoriesDCIcon
            //   }
        ]
    },
    {
        id: 'Division',
        title: 'DIVISION',
        type: 'group',
        icon: 'icon-support',
        children: [
            {
                id: 'compactingdivision',
                title: 'Compacting Receiving Note',
                type: 'item',
                url: '/compacting-receiving-note',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: compactingIcons
            },
            {
                id: 'compactingdivisionInward',
                title: 'Compacting Despatch Note',
                type: 'item',
                url: '/compacting-delivery-note',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: compactingIcons
            },
            {
                id: 'compactingdivisionAuthorize',
                title: 'Compacting Authorize',
                type: 'item',
                url: '/compacting-authorize-note',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: compactingIcons
            },
        ]
    },
    {
        id: 'Billing',
        title: 'BILLING',
        type: 'group',
        icon: 'icon-support',
        children: [
            {
                id: 'Pim',
                title: 'PIM',
                type: 'item',
                url: '/pim',
                classes: 'nav-item',
                icon: 'feather icon-credit-card',
                img: PIMIcon
            },
            {
                id: 'VerifyPim',
                title: 'Verify PIM',
                type: 'item',
                url: '/verify-pim',
                classes: 'nav-item',
                icon: 'feather icon-credit-card'
            },
            {
                id: 'billEntries',
                title: 'Bill Entry',
                type: 'item',
                url: '/billentries',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: billEntriesIcon
            },
            {
                id: 'editbillEntries',
                title: 'Edit Bill Entries',
                type: 'item',
                url: '/Edit-Entries',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: billEntriesIcon
            },


            {
                id: 'debitMemo',
                title: 'Debit Memo',
                type: 'item',
                url: '/Debit-Memo',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: billEntriesIcon
            },


            // {
            //     id: 'editbillverification',
            //     title: 'Edit Verification',
            //     type: 'item',
            //     url: '/edit-verification',
            //     classes: 'nav-item',
            //     icon: 'feather icon-briefcase',
            //     img: billEntriesIcon
            // },
            {
                id: 'Verifybill',
                title: 'Verify Bill Entry',
                type: 'item',
                url: '/verify-billentry',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: billEntriesIcon
            },
            {
                id: 'verifiedBills',
                title: 'Verified Bills',
                type: 'item',
                url: '/verifiedBills',
                classes: 'nav-item',
                icon: 'feather icon-success',
                img: verifiedBillsIcon
            },
            {
                id: 'closebillReport',
                title: 'Close BillEntry Report',
                type: 'item',
                url: '/Close-BillEntry-Report',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: billEntriesIcon
            },

            {
                id: 'CashRequisition',
                title: 'Cash Requisition',
                type: 'item',
                url: '/cash-requisition',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: billEntriesIcon
            },

            {
                id: 'CostCenterReport',
                title: 'Cost Center Report',
                type: 'item',
                url: '/cost-center-report',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: billEntriesIcon
            },

            {
                id: 'DirectBilling',
                title: 'Direct Billing',
                type: 'item',
                url: '/direct-billing',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: billEntriesIcon
            },

            {
                id: 'billEntryall',
                title: 'Bill Entry Report',
                type: 'item',
                url: '/bill-entries-reports',
                classes: 'nav-item',
                icon: 'feather icon-file-minus',
                img: programWiseReportIcon
            },

            // {
            //     id: 'contractorbill',
            //     title: 'Contractor Bill',
            //     type: 'item',
            //     url: '/Contractor-Bill',
            //     classes: 'nav-item',
            //     icon: 'feather icon-briefcase',
            //     img: billEntriesIcon
            // },
            {
                id: 'billPayment',
                title: 'Bill Payment',
                type: 'item',
                url: '/bill-payment',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: billPaymentsIcon
            },
            {
                id: 'billReceiving',
                title: 'Bill Receiving',
                type: 'item',
                url: '/bill-receiving',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: billPaymentsIcon
            },
            {
                id: 'billReceivingVerify',
                title: 'Bill Receiving Verify',
                type: 'item',
                url: '/bill-receiving-verify',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: programWiseReportIcon
            },
            {
                id: 'billReceivingReport',
                title: 'Bill Receiving Report',
                type: 'item',
                url: '/bill-receiving-report',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: programWiseReportIcon
            },
            {
                id: 'programDiscount',
                title: 'Program Discount',
                type: 'item',
                url: '/program-discount',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: programWiseReportIcon
            },
        ]
    },
    {
        id: 'Reports',
        title: 'REPORT',
        type: 'group',
        icon: 'icon-support',
        children: [
            // {
            //     id: 'Reports',
            //     title: 'Reports - All',
            //     type: 'item',
            //     url: '/reports',
            //     classes: 'nav-item',
            //     icon: 'feather icon-box',
            //     img: programWiseReportIcon
            // },
            {
                id: 'ocrReports',
                title: 'OCR Reports',
                type: 'item',
                url: '/ocr-reports',
                classes: 'nav-item',
                icon: 'feather icon-file-minus',
                img: programWiseReportIcon
            },


            {
                id: 'ocrClosedReports',
                title: 'OCR Closed Reports',
                type: 'item',
                url: '/ocr-closed-reports',
                classes: 'nav-item',
                icon: 'feather icon-file-minus',
                img: programWiseReportIcon
            },

            {
                id: 'debitMemoReport',
                title: 'Debit Memo Report',
                type: 'item',
                url: '/debit-memo-reports',
                classes: 'nav-item',
                icon: 'feather icon-file-minus',
                img: programWiseReportIcon
            },

            {
                id: 'cuttingReports',
                title: 'Cutting Reports',
                type: 'item',
                url: '/cutting-reports',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: salesOrderIcon
            },
            {
                id: 'cuttingReportsDateWise',
                title: 'Cutting Reports Date Wise',
                type: 'item',
                url: '/cutting-reports-date-wise',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: programWiseReportIcon
            },

            {
                id: 'fabricReports',
                title: 'Fabric Reports',
                type: 'item',
                url: '/fabric-reports',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: salesOrderIcon
            },
            // {
            //     id: 'productionInfo',
            //     title: 'Production Info',
            //     type: 'item',
            //     url: '/production-info',
            //     classes: 'nav-item',
            //     icon: 'feather icon-file-minus',
            //     img: programWiseReportIcon
            // },

            {
                id: 'styleUpChargeReports',
                title: 'Style Upcharge Reports',
                type: 'item',
                url: '/style-upCharge-reports',
                classes: 'nav-item',
                icon: 'feather icon-anchor',
                img: styleCreationIcon
            },

            {
                id: 'stitchingReports',
                title: 'Stitching Reports',
                type: 'item',
                url: '/stitching-reports',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: programWiseReportIcon
            },

            {
                id: 'Visitors',
                title: 'Visitors Reports',
                type: 'item',
                url: '/visitors-report',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: programWiseReportIcon
            },


            {
                id: 'StyleWiseReport',
                title: 'Style Wise Report',
                type: 'item',
                url: '/style-wise-report',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: programWiseReportIcon
            },

            {
                id: 'FabricStatusReport',
                title: 'Fabric Status Report',
                type: 'item',
                url: '/fabric-status-report',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: programWiseReportIcon
            },
            {
                id: 'CompactingStatusReport',
                title: 'Compacting Status Report',
                type: 'item',
                url: '/compacting-status-report',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: programWiseReportIcon
            },

            // {
            //     id: 'BillEntryReportsAll',
            //     title: 'Bill Entry Reports All',
            //     type: 'item',
            //     url: '/bill-entries-reports-all',
            //     classes: 'nav-item',
            //     icon: 'feather icon-box',
            //     img: programWiseReportIcon
            // },
            {
                id: 'programReport',
                title: 'Program Wise Report',
                type: 'item',
                url: '/program-wise-report',
                classes: 'nav-item',
                icon: 'feather icon-file-minus',
                img: programWiseReportIcon
            },
            {
                id: 'salesOrderRequirementReport',
                title: 'Sales Order Requirement Reports',
                type: 'item',
                url: '/sales-order-requirement-report',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: programWiseReportIcon
            },
            {
                id: 'stockReports',
                title: 'Stock Reports Summary',
                type: 'item',
                url: '/bulk/stock-report',
                classes: 'nav-item',
                icon: 'feather icon-file-minus',
                img: programWiseReportIcon
            },
            {
                id: 'stockReportsCp',
                title: 'Stock Reports - CP',
                type: 'item',
                url: '/stock-report-cp',
                classes: 'nav-item',
                icon: 'feather icon-file-minus',
                img: programWiseReportIcon
            },
            {
                id: 'yarnProjectionReports',
                title: 'Yarn Projection Reports',
                type: 'item',
                url: '/yarn-projection-reports',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: yarnProjectionIcon
            },
            {
                id: 'stockReportsledger',
                title: 'Stock Reports Ledger',
                type: 'item',
                url: '/bulk/stock-report-ledger',
                classes: 'nav-item',
                icon: 'feather icon-file-minus',
                img: programWiseReportIcon
            },

            {

                id: 'Costing',
                title: 'Costing',
                type: 'item',
                url: '/costing',
                classes: 'nav-item',
                icon: 'feather icon-briefcase',
                img: billEntriesIcon
            },
            {
                id: 'supplierReport',
                title: 'Supplier Wise Report',
                type: 'item',
                url: '/supplier-wise-report',
                classes: 'nav-item',
                icon: 'feather icon-file-minus',
                img: programWiseReportIcon
            },
            {
                id: 'activeReport',
                title: 'Active Parties',
                type: 'item',
                url: '/active-parties',
                classes: 'nav-item',
                icon: 'feather icon-file-minus',
                img: programWiseReportIcon
            },
            {
                id: 'compactingReport',
                title: 'Compacting Report',
                type: 'item',
                url: '/compacting-report',
                classes: 'nav-item',
                icon: 'feather icon-file-minus',
                img: programWiseReportIcon
            },
            {
                id: 'costingReport',
                title: 'Costing Report',
                type: 'item',
                url: '/costing-report',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: salesOrderIcon
            },
            {
                id: 'productionReport',
                title: 'Production Report',
                type: 'item',
                url: '/production-report',
                classes: 'nav-item',
                icon: 'feather icon-file-minus',
                img: programWiseReportIcon
            },

            {
                id: 'RNPendingReport',
                title: 'Compacting InHouse Report',
                type: 'item',
                url: '/rn-pending-report',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: programWiseReportIcon
            },

            // {
            //     id: 'projectionReport',
            //     title: 'Projection Report',
            //     type: 'item',
            //     url: '/projection-report',
            //     classes: 'nav-item',
            //     icon: 'feather icon-file-minus',
            //     img: programWiseReportIcon
            // },
        ]
    },
    {
        id: 'Order',
        title: 'ORDER',
        type: 'group',
        icon: 'icon-support',
        children: [
            {
                id: 'salesOrder',
                title: 'Sales Order',
                type: 'item',
                url: '/sale-order',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: salesOrderIcon
            },
            {
                id: 'salesOrderEdit',
                title: 'Sales Order Requirement',
                type: 'item',
                url: '/sales-order-requirement',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: salesOrderIcon
            },

        ]
    },

    {
        id: 'OutStanding',
        title: 'OUTSTANDING',
        type: 'group',
        icon: 'icon-support',
        children: [
            {
                id: 'YarnOutStanding',
                title: 'Yarn OutStanding',
                type: 'item',
                url: '/yarn-outStanding',
                classes: 'nav-item',
                icon: 'feather icon-credit-card',
                img: salesOrderIcon
            },
            {
                id: 'YarnProjectionOutStanding',
                title: 'Yarn Projection OutStanding',
                type: 'item',
                url: '/yarn-projection-outStanding',
                classes: 'nav-item',
                icon: 'feather icon-credit-card',
                img: salesOrderIcon
            },
        ]
    },

    {
        id: 'ProcessFlow',
        title: 'PROCESS FLOW',
        type: 'group',
        icon: 'icon-support',
        children: [
            // {
            //     id: 'ProgramMapping',
            //     title: 'Program Mapping',
            //     type: 'item',
            //     url: '/program-mapping',
            //     classes: 'nav-item',
            //     icon: 'feather icon-sidebar',
            //     img: programMappingIcon
            // },
            {
                id: 'ProgramConstarint',
                title: 'Program Constraint',
                type: 'item',
                url: '/program-constarint',
                classes: 'nav-item',
                icon: 'feather icon-sidebar',
                img: programConstraintIcon
            },
            {
                id: 'Process',
                title: 'Process',
                type: 'item',
                url: '/process',
                classes: 'nav-item',
                icon: 'feather icon-sidebar',
                img: programAssignStyleMasterIcon
            },
            {
                id: 'ProcessBulk',
                title: 'Process Bulk',
                type: 'item',
                url: '/bulk/process',
                classes: 'nav-item',
                icon: 'feather icon-sidebar',
                img: programAssignStyleMasterIcon
            },
            // {
            //     id: 'AssignProcess',
            //     title: 'Assign Process',
            //     type: 'item',
            //     url: '/assign-process',
            //     classes: 'nav-item',
            //     icon: 'feather icon-sidebar'
            // },
            {
                id: 'ProcessAssignStyleMaster',
                title: 'Process Assign Style Master',
                type: 'item',
                url: '/process-assign-style-master',
                classes: 'nav-item',
                icon: 'feather icon-sidebar',
                img: programAssignStyleMasterIcon
            },
            {
                id: 'ProcessAssignStyleMasterBulk',
                title: 'Process Assign Style Master Bulk',
                type: 'item',
                url: '/bulk/process-assign-style-master-basic',
                classes: 'nav-item',
                icon: 'feather icon-sidebar',
                img: programAssignStyleMasterIcon
            }
        ]
    },

    {
        id: 'shipment',
        title: 'SHIPMENT',
        type: 'group',
        icon: 'icon-support',
        children: [
            {
                id: 'shippingPlan',
                title: 'Shipping Plan',
                type: 'item',
                url: '/shipping-plan',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: salesOrderIcon
            },

        ]
    },
    {
        id: 'Warehouse',
        title: 'WAREHOUSE',
        type: 'group',
        icon: 'icon-support',
        children: [
            {
                id: 'WarehouseStyle',
                title: 'Warehouse Style',
                type: 'item',
                url: '/ware-house-style',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: salesOrderIcon
            },
            {
                id: 'packingEntries',
                title: 'Warehouse Inward',
                type: 'item',
                url: '/warehouse-inward',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: salesOrderIcon
            },
            {
                id: 'productDispatch',
                title: 'Warehouse Dispatch',
                type: 'item',
                url: '/warehouse-dispatch',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: salesOrderIcon
            },
            {
                id: 'WarehouseStock',
                title: 'Warehouse Stock',
                type: 'item',
                url: '/warehouse-stock',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: salesOrderIcon
            },
            {
                id: 'warehouseReceiving',
                title: 'Warehouse Receiving',
                type: 'item',
                url: '/warehouse-receiving',
                classes: 'nav-item',
                icon: 'feather icon-box',
                img: salesOrderIcon
            },
        ]
    },
    {
        id: 'Roles',
        title: 'ROLES',
        type: 'group',
        icon: 'icon-support',
        children: [
            {
                id: 'Roles',
                title: 'Roles',
                type: 'item',
                url: '/roles',
                classes: 'nav-item',
                icon: 'feather icon-sidebar',
                img: rolesIcon
            },
            {
                id: 'UserHeader',
                title: 'User Header',
                type: 'item',
                url: '/user-header',
                classes: 'nav-item',
                icon: 'feather icon-users',
                img: uesrHeaderIcon
            },
            {
                id: 'UserAccessInfo',
                title: 'User Access Info',
                type: 'item',
                url: '/user-access-info',
                classes: 'nav-item',
                icon: 'feather icon-user-check',
                img: userAccInfoIcon
            }
        ]
    },
    {
        id: 'Feedback',
        title: 'FEEDBACK',
        type: 'group',
        icon: 'icon-support',
        children: [
            {
                id: 'Feedback',
                title: 'Feedback',
                type: 'item',
                url: '/feedback-master',
                classes: 'nav-item',
                icon: 'feather icon-sidebar'
            },
            {
                id: 'AsanaError Points',
                title: 'AsanaError Points',
                type: 'item',
                url: '/asanaError-Points',
                classes: 'nav-item',
                icon: 'feather icon-sidebar'
            }
        ]
    }
]


